import values from 'lodash/values';
import ListingSortOrder from '@domain-group/fe-allhomes-library/lib/enums/listing-sort-order';
export var DEFAULT_SORT = ListingSortOrder.PRICE_ASCENDING.urlSlug;
export default listingType => values(ListingSortOrder).filter(each => each.listingTypes == null || each.listingTypes.includes(listingType)).map(_ref => {
  var label = _ref.label,
    urlSlug = _ref.urlSlug;
  return {
    label,
    value: urlSlug
  };
});